import Experience from './Experience.js'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import Input from './Input.js'
import Resources from './Utils/Resources.js'

export default class Camera
{
    //#parallaxX = 0
    //#parallaxY = 0

    constructor()
    {
        this.experience = new Experience()

        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.input = this.experience.input
        this.time = this.experience.time
        this.resources = this.experience.resources

        this.cameraGroup = new THREE.Group()

        this.setInstance()
        //this.setOrbitControls()

        console.log('Camera initialized')
    }
    
    setInstance()
    {
        this.instance = new THREE.PerspectiveCamera(72, this.sizes.width / this.sizes.height, 0.1, 100)
        this.instance.position.set(0, 0, 13)

        this.cameraGroup.add(this.instance)        

        this.scene.add(this.cameraGroup)
    }
    
    setOrbitControls()
    {
        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
    }

    resize()
    {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update()
    {
        //this.controls.update()
        //this.cameraGroup.position.y = -this.input.scrollY / this.sizes.height * 10
        
        if(this.input)
        {
            // scroll for camera
            const targetY = -this.input.scrollY / this.sizes.height * 10
            this.instance.position.y += (targetY - this.instance.position.y) * 5 * this.time.delta

            // parallax for camera group
            if(!this.experience.isMobile) {
                this.cameraGroup.position.x += (this.input.mouseVector.x - this.cameraGroup.position.x) * 8 * this.time.delta  
                this.cameraGroup.position.y += (this.input.mouseVector.y - this.cameraGroup.position.y) * 8 * this.time.delta
            }
        }
        
        
    }
}